<div class="container">
    <div class="row">
        <div class="xs-12 md-6 mx-auto">
            <div id="countUp">
                <div class="number" data-count="404">404</div>
                <div class="text">{{this.notFoundConstants.ERROR_TITLE}}</div>
                <div class="text">{{this.notFoundConstants.ERROR_DESCRIPTION}}</div>
            </div>
        </div>
    </div>
</div>
